import {Component, ElementRef, inject, Input, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {DxFileUploaderComponent} from "devextreme-angular";
import {UploadedEvent} from "devextreme/ui/file_uploader";

@Component({
    selector: 'form-photo',
    templateUrl: './form-photo.component.html',
    styleUrls: ['./form-photo.component.scss'],
    imports: [
        DxFileUploaderComponent,
        CommonModule,
    ],
})
export class FormPhotoComponent implements OnInit {
    @Input() link: string | null = null;

    @Input() editable = false;

    @Input() size = 124;

    @Input() uploadUrl: string;

    private elRef = inject(ElementRef);

    imageUrl: string | null = null;

    hostRef = this.elRef.nativeElement;

    ngOnInit() {
        if (this.link) {
            this.imageUrl = `url('${this.link}')`;
        }
    }

    protected onUploaded($event: UploadedEvent) {
        if ($event.request.status === 200) {
            this.imageUrl = `url('${$event.request.response.body}')`;
        }
    }
}
